import { render, staticRenderFns } from "./ItemFilterDetectionLayout.vue?vue&type=template&id=371dca5f&scoped=true"
import script from "./ItemFilterDetectionLayout.vue?vue&type=script&lang=js"
export * from "./ItemFilterDetectionLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371dca5f",
  null
  
)

export default component.exports